module.exports = __webpack_public_path__ + "img/base_restauration_fromage.ca035dbc.svg";